import React, { useState } from "react";

import { CSVLink } from "react-csv";

import { useBannedTeamsContext } from "../contexts/BannedTeams";
import { BannedTeamsList, CSVData } from "../types/bannedTeams";

const DownloadButton = (): React.JSX.Element => {
    const { umpires } = useBannedTeamsContext();

    const [csvData, setCSVData] = useState<Array<CSVData>>([]);
    const CSVHeaders = [
        { label: "Umpire", key: "umpire" },
        { label: "Banned Teams", key: "banned" },
    ];

    const generateCSVRow = (u: BannedTeamsList): CSVData => {
        return {
            umpire: u.name,
            banned: u.bannedTeams?.join(", "),
        };
    };

    const handleDownload = () => {
        const CSVData = umpires.map(u => generateCSVRow(u));
        setCSVData(CSVData);
    };

    return (
        <CSVLink
            data={csvData}
            headers={CSVHeaders}
            filename={`BannedUmpiresByTeam.${new Date().getTime()}.csv`}
            className="btn btn-primary"
            target="_blank"
            onClick={handleDownload}
        >
            Download Excel File
        </CSVLink>
    );
};

export default DownloadButton;
